import { FCX, useOutsideClick } from "@datassential/platform-ui-lib";
import React, { useRef } from 'react';
import cn from 'classnames';

import Popup from '@components/Popup';

type Modifier = 'no-pad';

const Modal: FCX<{
	onClose: () => void;
	modifiers?: Modifier[];
	hasCloseButton?: boolean;
	closeOnOutsideClick?: boolean;
}> = ({
	onClose = () => {},
	hasCloseButton = true,
	modifiers = [],
	closeOnOutsideClick = true,
	className,
	children,
	testId,
	style,
}) => {
	const refNode = useRef<HTMLDivElement>(null);

	useOutsideClick({
		ref: refNode,
		callback: onClose,
		isDisabled: !closeOnOutsideClick,
	});

	return (
		<Popup style={{ zIndex: 4 }} hasWrapper>
			<div
				className={cn(
					'Modal',
					className,
					...modifiers.map(modifier => `is-${modifier}`),
				)}
			>
				<div
					ref={refNode}
					className="Modal__window"
					data-testid={testId}
					style={style}
				>
					{hasCloseButton && (
						<button onClick={onClose} className="Modal__close">×</button>
					)}
					<div className="Modal__body">
						{children}
					</div>
				</div>
			</div>
		</Popup>
	);
};

export default Modal;